import axios from "axios";
import store from "../redux/indexRedux";

export const instance = axios.create({
  baseURL: "https://admin.icargoapp.com/public/api/",
  // baseURL: "http://127.0.0.1:8000/api",
});

instance.interceptors.request.use(
  async (config) => {
    // Obtener el token del estado de Redux
    const state = store.getState();
    const currentUser = state?.auth?.currentUser;
    const token = currentUser?.token;
    
    console.log("HTTP Request:", {
      method: config.method,
      url: config.url,
      hasToken: !!token,
      tokenLength: token?.length || 0
    });
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn("WARNING: No token found!", {
        currentUser: currentUser ? Object.keys(currentUser) : null
      });
    }
    
    config.headers.Accept = "application/json";
    config.headers["Content-Type"] = "application/json";

    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error("HTTP Response Error:", {
      status: error?.response?.status,
      url: error?.config?.url,
      method: error?.config?.method,
      errorData: error?.response?.data
    });
    return Promise.reject(error);
  }
);

export default instance;
